import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useVerificationStatus = () => {
  const [isVerified, setIsVerified] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  const checkVerificationStatus = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        setIsVerified(null);
        setLoading(false);
        return;
      }

      // Check if user was verified through social login
      const urlParams = new URLSearchParams(window.location.search);
      const autoVerified = urlParams.get('auto_verified') === 'true';
      
      if (autoVerified) {
        toast({
          title: "Account Verified ✓",
          description: "Your account has been automatically verified through social login.",
        });
      }

      const { data: profile, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('user_id', user.id)
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Error checking verification status:', error);
        setIsVerified(false);
      } else {
        // Check if is_verified exists in the profile data (may not be in types yet)
        const profileWithVerification = profile as any;
        setIsVerified(profileWithVerification?.is_verified === true);
      }
    } catch (error) {
      console.error('Error checking verification status:', error);
      setIsVerified(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkVerificationStatus();
  }, []);

  return {
    isVerified,
    loading,
    refetch: checkVerificationStatus
  };
};